module.exports = __webpack_public_path__ + "img/cubo_mas_Arrows.8bb44c23.png";